import React from 'react';
import { Stack } from '@mui/material';

const CustomTabPanel = ({ children, value, index, dataTestID }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabPanel-${index}`}
      data-testid={dataTestID}
      aria-labelledby={`simple-tab-${index}`}
    >
      <Stack spacing={2}>{children}</Stack>
    </div>
  );
};

export default CustomTabPanel;
